import React from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import About from '../components/About';
import Portfolio from '../components/Portfolio';
import Team from '../components/Team';
import Contact from '../components/Contact';

function HomePage() {
  return (
    <div className="page-transition">
      <Hero />
      <Services />
      <About />
      <Portfolio />
      <Team />
      <Contact />
    </div>
  );
}

export default HomePage;